import Router from "./Router";
import "./assets/styles/reset.css";

const App = () => {
  return <Router />;
};

export default App;
